import { useTabNavConfig } from '@/hooks/useTabNavConfig'
import { Redirect } from 'expo-router'

const tabsSegmentMap = {
  play: 'play',
  home: 'home',
  learning: 'learning',
  membership: 'membership',
  profile: 'profile'
} as const

export default function RootScreen() {
  const { initialRoute } = useTabNavConfig().config

  const initialRouteName = initialRoute.replace('Screen', '') as keyof typeof tabsSegmentMap

  return <Redirect href={`/${initialRouteName}`} />
}
